/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import { Button } from 'ui/atoms/Button/Button';
import { Faq } from 'ui/atoms/Faq/Faq';
import { StatsBlock } from 'ui/molecules/StatsBlock/StatsBlock';
import { CtaSection } from 'ui/organisms/CtaSection/CtaSection';

import styles from './MasterDataManagementPage.module.scss';

import { MdmHero } from './sections/MdmHero/MdmHero';
import { MdmProblem } from './sections/MdmProblem/MdmProblem';
import { MdmMatchingSteps } from './sections/MdmMatchingSteps/MdmMatchingSteps';
import { MdmDataAttributes } from './sections/MdmDataAttributes/MdmDataAttributes';
import { MdmLinkage } from './sections/MdmLinkage/MdmLinkage';
import { MdmMonitoring } from './sections/MdmMonitoring/MdmMonitoring';
import { MdmWhySection } from './sections/MdmWhySection/MdmWhySection';
import { MdmTestimonial } from './sections/MdmTestimonial/MdmTestimonial';
import { MdmDelivery } from './sections/MdmDelivery/MdmDelivery';
import { getCoverageStats, getFaqData } from './MasterDataManagementPage.data';

export const MasterDataManagementPage = () => {
  const { t } = useInt();

  return (
    <div className={styles.wrapper}>
      <MdmHero />
      <StatsBlock theme="dark" hasPadding={false} className={styles.coverageStats} features={getCoverageStats(t)} />
      <MdmProblem />
      <MdmMatchingSteps />
      <MdmDataAttributes />
      <MdmLinkage />
      <MdmMonitoring />
      <MdmWhySection />
      <MdmTestimonial />
      <MdmDelivery />
      <CtaSection
        spotlight
        title={t('Put one company identity behind every system')}
        description={t(
          "Send us a sample of your account or vendor file. We'll return it resolved, deduplicated, and enriched — with the source and timestamp on every field, so you can judge the match rate on evidence.",
        )}
        actions={
          <>
            <Button type="blue" size="xl" href="/free-trial">
              {t('Free Trial')}
            </Button>
            <Button type="dark-outline" size="xl" href="/book-a-demo">
              {t('Book a demo')}
            </Button>
          </>
        }
      />
      <Faq title={t('Questions data teams ask first')} data={getFaqData(t)} />
    </div>
  );
};
